export const getTokenHCM = async (resource) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/recuperarToken`).then(
    (response) => {
      result = response.body.access_token;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const getPatientHcm = async (resource, rut, access_token) => {
  let result;
  const token = access_token ? access_token : await getTokenHCM(resource);
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/filter_by_document/${rut}/${token}/1`).then(
    (response) => {
      result = response;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const getPatientQx = async (resource, rut, access_token) => {
  let result;
  const token = await getTokenHCM(resource);
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/filter_by_document_qx/${rut}/${token}/1`).then(
    (response) => {
      result = response.body;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const getPatientEpi = async (resource, rut, access_token) => {
  let result;
  const token = await getTokenHCM(resource);
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/filter_by_document_epi/${rut}/${token}/1`).then(
    (response) => {
      result = response.body;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const getPatientRecipe = async (resource, rut, access_token) => {
  let result;
  const token = await getTokenHCM(resource);
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/filter_by_document_recipe/${rut}/${token}/1`).then(
    (response) => {
      console.log(response);
      result = response.body;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};
